// extracted by mini-css-extract-plugin
export default {"container":"Banners_container__pUO4z"};